import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withTranslation, Trans } from 'react-i18next';
import withCustomComponent from 'ui/components/withCustomComponent';
import DefaultLayout from 'ui/layouts/DefaultLayout';
import Link from 'next/link';
import moment from 'moment';
import { routes } from 'env/routes';
import { removeHtml } from 'env/utils/strings';
import { privateRoute } from 'env/privateRoute';
import { withAppWrapper } from 'ui/components/withAppWrapper';



@withAppWrapper()
@withCustomComponent('FaqPage')
@withTranslation()
@inject('contentStore', 'appStore', 'authStore')
@observer
class FaqPage extends Component {
  componentDidMount() {
    const { contentStore } = this.props;
    contentStore.loadFaqArticles();
  }

  render() {
    const { t, contentStore, appStore } = this.props;
    const { business } = appStore;
    const { articlesByGroup } = contentStore;
    return (
      <DefaultLayout
        componentName={this.props.componentName}
        title={t('Frequently Asked Questions') + ' - ' + business.Name}
      >
        <main className="content content--custom faq" role="main">
          <div className="container pb-32">
            <div className="">
              <h2>{t('Frequently Asked Questions')}</h2>
            </div>

            {articlesByGroup.map((group) => (
              <>
                <hr className="mt-32 mb-24" />
                <h5>{group.group != 'null' ? t(group.group) : t('General')}</h5>
                {group.articles.map((article) => (
                  <div className="card py-20 px-24 h-auto mb-8 mw-820">
                    <div className="d-flex">
                      {article.HasImage && (
                        <div
                          className="pr-16"
                          style={{ width: 66, minWidth: 66 }}
                        >
                          <img
                            className="img-fluid"
                            src={`${
                              business.NativeHomeUrlWithLanguage
                            }/faq/GetImage?id=${article.Id}&w=${100}&h=100`}
                            alt={removeHtml(article.Title)}
                          />
                        </div>
                      )}
                      <div>
                        <div className="d-flex align-items-center">
                          <Link
                            href={routes.faq_by_id()}
                            as={routes.faq_by_id(article)}
                          >
                            <a className="mr-4 text-gray-900">
                              <strong>{article.Title}</strong>
                            </a>
                          </Link>
                          <Link
                            href={routes.faq_by_id()}
                            as={routes.faq_by_id(article)}
                          >
                            <a className="d-inline-flex align-items-center text-gray-600 tdn">
                              <i className="icon-arrow-right-small fs-24 mt-2"></i>
                            </a>
                          </Link>
                        </div>
                        <p className="fs-14 text-gray-700 pt-4 mb-0">
                          {article.SummaryText}
                        </p>
                        {article.FullText && (
                          <div className="mt-12">
                            <Link
                              href={routes.faq_by_id()}
                              as={routes.faq_by_id(article)}
                            >
                              <a className="btn btn-gray btn-sm">
                                {t('Read more')}
                              </a>
                            </Link>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ))}
          </div>
        </main>
      </DefaultLayout>
    );
  }
}

export default FaqPage;
